import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TokenServiceService {

  private randToken = new BehaviorSubject<any>({});
  randomTokenBifur = this.randToken.asObservable();

  private _kccToken: string = null;
  private _kccSessionActive: boolean = false;

  constructor() { }

  setToken(token: any){
    this.randToken.next(token)
  }

  setKccToken(token: string): void {
    this._kccToken = token;
    this._kccSessionActive = true;
  }

  getKccToken(): string {
    return this._kccToken;
  }

  isKccSessionActive(): boolean {
    return this._kccSessionActive;
  }

  clearKccToken(): void {
    this._kccToken = null;
    this._kccSessionActive = false;
  }

}
